module.exports = __webpack_public_path__ + "static/media/dart.29271246.webp";